// W37b (2026-10-20): honest "not available" card for a section whose
// source is not composed on this deployment. The reason is the server's
// own code (NO_PRESENCE_SOURCE, NO_SALES_SOURCE, ...) and the note is the
// server's own sentence when it sends one; nothing here types a number.
// Shared by Team Live and Executive Live.
import type { ReactNode } from 'react';

export interface NotAvailableCardProps {
  title: string;
  reason: string;
  note?: string | null;
  dataComponent: string;
}

export const NOT_AVAILABLE_LABEL = 'Not available yet';

export function NotAvailableCard({ title, reason, note, dataComponent }: NotAvailableCardProps): ReactNode {
  return (
    <section className="n-card" data-component={dataComponent} data-testid={dataComponent}>
      <div className="n-head">
        <h2>{title}</h2>
        <small>{NOT_AVAILABLE_LABEL}</small>
      </div>
      <div className="n-body">
        <p>
          <span className="n-pill amber">{NOT_AVAILABLE_LABEL}</span> <code>{reason}</code>
        </p>
        {note ? <p style={{ marginTop: 10 }}>{note}</p> : null}
      </div>
    </section>
  );
}
